// Replace legacy cache-first workers; maintenance-mobile has its own scope.
export default function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  const install = () => navigator.serviceWorker.register(
    `${process.env.PUBLIC_URL || ''}/service-worker.js`, { updateViaCache: 'none' }
  ).catch(() => { /* Offline: retry on the next visit. */ });
  if (document.readyState === 'complete') install();
  else window.addEventListener('load', install, { once: true });
}
